import React from 'react';
import $ from '../../../../offline/jquery.min.js';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ConfigService from '../../../Services/api/Config';

class Tooltip extends React.PureComponent {
  constructor(props) {
    super(props);
    this.parentElement = React.createRef();
    this.element = React.createRef();
    this.state = {
      onElement: false,
      bottom: this.props.className && this.props.className.includes('Tooltip_Bottom'),
      top: this.props.className && this.props.className.includes('Tooltip_Top'),
      left: this.props.className && this.props.className.includes('Tooltip_Left'),
      blue: this.props.className && this.props.className.includes('Tooltip_Blue')
    };
  }

  parentOver = () => {
    const { onElement, left, blue, bottom, top } = this.state;
    const { timeout } = this.props;
    const parent_element = $(this.parentElement.current);
    const element = $(this.element.current);
    if (onElement) {
      return;
    }
    element.stop();
    const height = element.outerHeight();
    const parent = parent_element.outerWidth();
    const parent_height = parent_element.outerHeight();
    const right = $(window).width() - (parent_element.offset().left + parent_element.outerWidth());
    element.fadeIn('slow');
    if (right < element.outerWidth() || left) {
      if (!left) {
        element.addClass('Tooltip_Left');
      }
      if (blue) {
        element.css({ minWidth: element.find('span').width(), right: parent, top: -(height / 2) + parent_height / 2 });
      } else {
        element.css({ right: parent + 20, top: -(height / 2) + parent_height / 2 });
      }
      if (bottom) {
        element.css({ minWidth: element.find('span').width(), right: 0, top: parent_height + 5 });
      }
      if (top) {
        element.css({ minWidth: element.find('span').width(), right: 0, top: -(height + 5) });
      }
    } else {
      if (blue) {
        element.css({ minWidth: element.find('span').width(), left: parent, top: -(height / 2) + parent_height / 2 });
      } else {
        element.css({ left: parent + 20, top: -(height / 2) + parent_height / 2 });
      }
      if (bottom) {
        element.css({ minWidth: element.find('span').width(), left: -(element.outerWidth() / 2) + parent / 2, top: parent_height + 10 });
      }
      if (top) {
        element.css({ minWidth: element.find('span').width(), left: -(element.outerWidth() / 2) + parent / 2, top: -(height + 10) });
      }
    }
    if (timeout !== undefined) {
      setTimeout(() => {
        element.fadeOut('fast');
      }, timeout);
    }
  };

  parentLeave = () => {
    const element = $(this.element.current);
    element.stop();
    element.fadeOut('fast');
    this.setState({
      onElement: false
    });
  };

  elementOver = () => {
    const element = $(this.element.current);
    element.stop();
    element.fadeOut('fast');
    this.setState({
      onElement: true
    });
  };

  render() {
    const { children, message, className, classParent } = this.props;

    const styleTooltip = {
      backgroundColor:
        className && className.includes('Tooltip_Blue') ? ConfigService.getColor('secondaryColor', 0.8) : ConfigService.getColor('warningColor', 0.8)
    };
    return (
      <div className={classNames('TooltipParent', classParent)} ref={this.parentElement} onMouseOver={() => this.parentOver()} onMouseLeave={() => this.parentLeave()}>
        {children}
        <div className={classNames('Tooltip', className)} ref={this.element} onMouseOver={() => this.elementOver()} style={styleTooltip}>
          <span>{message}</span>
        </div>
      </div>
    );
  }
}

Tooltip.propTypes = {
  children: PropTypes.any,
  timeout: PropTypes.string,
  message: PropTypes.any,
  className: PropTypes.string
};

export default Tooltip;
